module.exports = __webpack_public_path__ + "39892ceaa6d9febd504ec0a7b2aaca33.svg";